"use client";

// Top-level error boundary. This catches errors thrown in the root layout
// itself, so it must render its own <html> and <body> — the normal layout
// (and its CSS, including the theme variables) is not available here. Colors
// are hardcoded to the brand light-mode palette as a self-contained fallback.
export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: "1rem",
          padding: "4rem 1.5rem",
          background: "hsl(40 47% 96%)",
          color: "hsl(0 3% 6%)",
          fontFamily:
            "'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif",
        }}
      >
        <h1 style={{ fontSize: "2rem", margin: 0 }}>Something went wrong</h1>
        <p style={{ fontSize: "1.125rem", maxWidth: "32rem", opacity: 0.8 }}>
          An unexpected error stopped the page from loading. Please try again.
        </p>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            fontSize: "1rem",
            padding: "0.625rem 1.5rem",
            borderRadius: "999px",
            border: "1px solid hsl(0 3% 6%)",
            background: "hsl(0 3% 6%)",
            color: "hsl(40 47% 96%)",
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
